import { useCallback, useEffect, useState } from 'react';
import { getLocale, setLocale as persistLocale, t } from '../i18n/index';

export type AppLocale = 'en' | 'hi';

const LOCALE_EVENT = 'ci-locale-change';

export function useAppTranslation() {
  const [locale, setLocaleState] = useState<AppLocale>(() => getLocale());

  const setLocale = useCallback((next: AppLocale) => {
    persistLocale(next);
    setLocaleState(next);
    window.dispatchEvent(new Event(LOCALE_EVENT));
  }, []);

  useEffect(() => {
    const handler = () => setLocaleState(getLocale());
    window.addEventListener(LOCALE_EVENT, handler);
    return () => window.removeEventListener(LOCALE_EVENT, handler);
  }, []);

  return {
    locale,
    setLocale,
    t: (key: string) => t(key, locale),
  };
}

export default useAppTranslation;
